<mpro-dropdown
  [disabled]="disabled"
  [title]="title"
  [inputValue]="inputValue ? inputValue[nameProperty] : ''">
  <mpro-dropdown-item *ngFor="let o of options"
                      [leftText]="o[nameProperty]"
                      [disabled]="o.disabled"
                      [selected]="inputValue[nameProperty] === o[nameProperty]"
                      [showLock]="!!o.authDisabled"
                      (itemClicked)="onSelect(o)"></mpro-dropdown-item>
</mpro-dropdown>
